// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file emoji-reaction.proto (syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { MessageType } from './enums_pb'
import { file_enums } from './enums_pb'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file emoji-reaction.proto.
 */
export const file_emoji_reaction: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChRlbW9qaS1yZWFjdGlvbi5wcm90byKiAgoNRW1vamlSZWFjdGlvbhINCgVjbG9jaxgBIAEoBBIPCgdjaGF0X2lkGAIgASgJEhIKCm1lc3NhZ2VfaWQYAyABKAkSIgoMbWVzc2FnZV90eXBlGAQgASgOMgwuTWVzc2FnZVR5cGUSIQoEdHlwZRgFIAEoDjITLkVtb2ppUmVhY3Rpb24uVHlwZRIRCglyZXRyYWN0ZWQYBiABKAgSEQoFZ3JhbnQYByABKAxCAhgBInAKBFR5cGUSHwobVU5LTk9XTl9FTU9KSV9SRUFDVElPTl9UWVBFEAASCAoETE9WRRABEg0KCVRIVU1CU19VUBACEg8KC1RIVU1CU19ET1dOEAMSCQoFTEFVR0gQBBIHCgNTQUQQBRIJCgVBTkdSWRAGYgZwcm90bzM',
    [file_enums],
  )

/**
 * @generated from message EmojiReaction
 */
export type EmojiReaction = Message<'EmojiReaction'> & {
  /**
   * clock Lamport timestamp of the chat message
   *
   * @generated from field: uint64 clock = 1;
   */
  clock: bigint

  /**
   * chat_id the ID of the chat the message belongs to, for query efficiency the chat_id is stored in the db even though the
   * target message also stores the chat_id
   *
   * @generated from field: string chat_id = 2;
   */
  chatId: string

  /**
   * message_id the ID of the target message that the user wishes to react to
   *
   * @generated from field: string message_id = 3;
   */
  messageId: string

  /**
   * message_type is (somewhat confusingly) the ID of the type of chat the message belongs to
   *
   * @generated from field: MessageType message_type = 4;
   */
  messageType: MessageType

  /**
   * type the ID of the emoji the user wishes to react with
   *
   * @generated from field: EmojiReaction.Type type = 5;
   */
  type: EmojiReaction_Type

  /**
   * whether this is a rectraction of a previously sent emoji
   *
   * @generated from field: bool retracted = 6;
   */
  retracted: boolean

  /**
   * Grant for organisation chat messages
   *
   * @generated from field: bytes grant = 7 [deprecated = true];
   * @deprecated
   */
  grant: Uint8Array
}

/**
 * Describes the message EmojiReaction.
 * Use `create(EmojiReactionSchema)` to create a new message.
 */
export const EmojiReactionSchema: GenMessage<EmojiReaction> =
  /*@__PURE__*/
  messageDesc(file_emoji_reaction, 0)

/**
 * @generated from enum EmojiReaction.Type
 */
export enum EmojiReaction_Type {
  /**
   * @generated from enum value: UNKNOWN_EMOJI_REACTION_TYPE = 0;
   */
  UNKNOWN_EMOJI_REACTION_TYPE = 0,

  /**
   * @generated from enum value: LOVE = 1;
   */
  LOVE = 1,

  /**
   * @generated from enum value: THUMBS_UP = 2;
   */
  THUMBS_UP = 2,

  /**
   * @generated from enum value: THUMBS_DOWN = 3;
   */
  THUMBS_DOWN = 3,

  /**
   * @generated from enum value: LAUGH = 4;
   */
  LAUGH = 4,

  /**
   * @generated from enum value: SAD = 5;
   */
  SAD = 5,

  /**
   * @generated from enum value: ANGRY = 6;
   */
  ANGRY = 6,
}

/**
 * Describes the enum EmojiReaction.Type.
 */
export const EmojiReaction_TypeSchema: GenEnum<EmojiReaction_Type> =
  /*@__PURE__*/
  enumDesc(file_emoji_reaction, 0, 0)
